import { render, staticRenderFns } from "./form-contacts.vue?vue&type=template&id=aa10c8de&lang=pug&"
import script from "./form-contacts.vue?vue&type=script&lang=js&"
export * from "./form-contacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports